<template>
  <v-col
    v-if="!authIsPending && !isLoggedIn"
    cols="10"
    alignment="center"
    justify="center"
    class="mx-auto"
    lg="7"
    xl="6"
  >
    <h2
      class="text-center success--text display-1 mb-3 font-weight-bold"
    >
      <v-icon
        x-large
        color="success"
      >
        mdi-check-circle
      </v-icon> Du er nu logget ud
    </h2>
    <v-row
      class="py-5"
      align="center"
      justify="center"
    >
      <v-btn
        x-large
        data-cy="logInAgain"
        @click="logInAgain"
      >
        Log ind igen
      </v-btn>
    </v-row>
  </v-col>
</template>

<script>
import { vxm } from '@/state'

export default {
  name: 'LoggedOut',
  data() {
    return {
    }
  },
  computed: {
    isLoggedIn() {
      return vxm.authUser.isLoggedIn
    },
    authIsPending() {
      return vxm.authUser.authIsPending
    },

  },
  watch: {
  },
  methods: {
    logInAgain() {
      this.$router.push({ name: 'home' })
    },
  },
}

</script>

<style scoped></style>
